import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./MainLayout.css";
import SidebarComponent from "./Sidebar/Sidebar";
import Header from "./header/Header";
import DisclaimerModal from "./DisclaimerModal";
import VideoTutorialModal from "./VideoTutorialModal/VideoTutorialModal";
import ReleaseNotesModal from "./ReleaseNotesModal/ReleaseNotesModal";
import ManageSubscriptionsModal from "./ManageSubscriptionsModal/ManageSubscriptionsModal";
import { ModalManagerProvider } from "./ModalManager/ModalManager";
import { ToastContainer } from "@msi/cobalt-react";

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isManageSubscriptionsOpen, setIsManageSubscriptionsOpen] = useState(false);

  // Check for manage-subscriptions query parameter on mount and location change
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.has('manage-subscriptions')) {
      setIsManageSubscriptionsOpen(true);
      // Clean up the URL by removing the query parameter
      searchParams.delete('manage-subscriptions');
      const newSearch = searchParams.toString();
      const newUrl = `${location.pathname}${newSearch ? `?${newSearch}` : ''}`;
      navigate(newUrl, { replace: true });
    }
  }, [location, navigate]);

  return (
    <ModalManagerProvider>
      <div className="app-layout">
        <DisclaimerModal />
        <VideoTutorialModal />
        <ReleaseNotesModal />
        <ManageSubscriptionsModal
          isOpen={isManageSubscriptionsOpen}
          onClose={() => setIsManageSubscriptionsOpen(false)}
        />
        <Header />
        <div className="main-layout-content">
          <SidebarComponent />
          <div className="main-content" style={{ position: "relative" }}>
            <ToastContainer
              containerId="default"
              style={{
                position: "absolute",
                top: 0,
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: 9999,
              }}
            />
            {children}
          </div>
        </div>
      </div>
    </ModalManagerProvider>
  );
};

export default MainLayout;